export default "__VITE_ASSET__296ovepx__"